module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/search-71ec8b33777fb6ee703a8219f6d65e77.svg";